import React from 'react';
import { Navigation } from '../components/Navigation';
import { GroomingSection } from '../components/GroomingSection';
import { Footer } from '../components/Footer';

const GroomingPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-20">
        <GroomingSection />
      </div>
      <Footer />
    </div>
  );
};

export default GroomingPage;
